import queryString from 'query-string'
import { compose, dissoc, objOf, toLower } from 'ramda'

import history from 'App/history'

import getPropertyOr from './getPropertyOr'

/* Getting browser query param, lowercasing it, 
comparing if equal to lowercased inserted query and removing it if so.
*/
export const removeQuery = (queryName): any =>
  compose(
    history.replace,
    objOf('search'),
    queryString.stringify,
    dissoc(toLower(queryName)),
    queryString.parse,
    toLower,
    // @ts-expect-error ts-migrate(2554) FIXME: Expected 1-6 arguments, but got 7.
    getPropertyOr({}, ['location', 'search']),
    // @ts-expect-error ts-migrate(2554) FIXME: Expected 0 arguments, but got 1.
  )(history)

export default {
  removeQuery,
}
